import CompletedCourse from '../UserCourses/CompleteCourse.component';
import IncompleteCourse from '../UserCourses/IncompleteCourse.component';
import AllCourses from '../UserCourses/AllCourses.component';
import React from 'react';
import PropTypes from 'prop-types';

const UserRouterComponent = ({ courses = [], user, chosen = '' }) => {
  let chosenItem;

  if (chosen === 'AllCourses') {
    chosenItem = <AllCourses courses={courses} data={user} />;
  } else if (chosen === 'IncompleteCourses') {
    chosenItem = <IncompleteCourse courses={courses} data={user} />;
  } else if (chosen === 'CompleteCourses') {
    chosenItem = <CompletedCourse courses={courses} data={user} />;
  } else {
    chosenItem = <AllCourses courses={courses} data={user} />;
  }

  return <>{chosenItem}</>;
};
UserRouterComponent.propTypes = {
  courses: PropTypes.array,
  user: PropTypes.object,
  chosen: PropTypes.string,
};

export default UserRouterComponent;
